// extracted by mini-css-extract-plugin
export default {"summary":"classes_summary__OB5y-","summary-rows":"classes_summary-rows__bqTBV","summary-row":"classes_summary-row__KyKbK","row":"classes_row__ZjbeA","border":"classes_border__eG7Lr"};